export const RatingStars = ({ rating, testId }) => {
  const value = rating == null ? 0 : Math.max(0, Math.min(5, Number(rating)));
  const label = `${String(value).replace(".", ",")} su 5 stelle`;
  return (
    <span className="rating-stars" role="img" aria-label={label} data-testid={testId}>
      <span className="rating-stars-muted" aria-hidden="true">★★★★★</span>
      <span className="rating-stars-gold" aria-hidden="true" style={{ width: `${value * 20}%` }}>★★★★★</span>
    </span>
  );
};